import React from "react";
import { useI18n } from "@/lib/i18n";
import Seo from "@/components/Seo";
export default function About() {
  const { t, locale } = useI18n();
  return (
    <>
      <Seo title="About" description={t.footer_disclaimer} canonicalPath="/about" locale={locale} />
      <div className="bp-container py-16 max-w-3xl">
        <h1 className="font-serif text-5xl mb-6">About BrandPassport</h1>
        <div className="space-y-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--bp-text-secondary)" }}>
          <p>BrandPassport is a public index of brand transparency. We document what brands publish about their products across seven categories aligned to the EU Digital Product Passport, and we track how ready each brand is for the DPP timeline set by ESPR (Regulation EU 2024/1781).</p>
          <p>We are neither a regulator nor a certifier. We do not issue Digital Product Passports. We summarise publicly available information and cite our sources.</p>
        </div>
      </div>
    </>
  );
}
